export default {
  "mb_1_3_0": {
    "productNameMustBeInAtLeastOneLanguage": "Product Name Must Be In At Least One Language",
    "finish": "Finish"
  }
}